const MAX_RELOAD_PERIOD_MILLIS = 30 * 60 * 1000

export function isChunkError(error) {
  return error?.message?.includes('Loading chunk')
}

export function handleChunkError(onReload) {
  const now = new Date().getTime()
  const lastRefreshed = getAutoLastRefreshedTime()

  if (!lastRefreshed || ((now - lastRefreshed) > MAX_RELOAD_PERIOD_MILLIS)) {
    updateLastAutoRefreshedTime()
    onReload ? onReload() : window.location.reload()
    return true
  }

  return false
}

export const LAST_AUTO_REFRESH_KEY = "LAST_AUTO_REFRESH_TIME"

export function getAutoLastRefreshedTime() {
  return parseInt(window.localStorage.getItem(LAST_AUTO_REFRESH_KEY))
}

export function updateLastAutoRefreshedTime() {
  window.localStorage.setItem(LAST_AUTO_REFRESH_KEY, "" + new Date().getTime())
}